export const KEY_UP = 38;
export const KEY_DOWN = 40;
export const KEY_ENTER = 13;
export const KEY_TAB = 9;
export const KEY_SPACE = 32;
export const KEY_N = 78;
export const KEY_P = 80;
export const KEY_ESC = 27;
